// extracted by mini-css-extract-plugin
export var aiStarIcon = "_cz-4";
export var closeButton = "_cz-6";
export var dismissButton = "_cz-3";
export var editImageWithAiContainer = "_cz-8";
export var imageUploadWrapper = "_cz-7";
export var misspelledWord = "_cz-5";
export var spellCheckContainer = "_cz-2";
export var spin = "_cz-1";
export var spinning = "_cz-0";